import { render, staticRenderFns } from "./LmDocumentsNewOrEdit.vue?vue&type=template&id=4247ad2c&scoped=true"
import script from "./LmDocumentsNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmDocumentsNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentsNewOrEdit.vue?vue&type=style&index=0&id=4247ad2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4247ad2c",
  null
  
)

export default component.exports